import { motion } from "framer-motion";
import { ArrowUpRight, Check } from "lucide-react";
import { PRODUCTS, CONTACT } from "./data";
import { Reveal, Eyebrow } from "./Reveal";

const ProductCard = ({ p, i }) => (
  <Reveal delay={i * 0.1} className={i === 1 ? "md:mt-20" : ""}>
    <motion.article whileHover="hover" data-testid={`product-card-${p.id}`} className="group">
      <div className="relative overflow-hidden rounded-t-[999px] rounded-b-[28px] aspect-[4/5] bg-[#E3F2FA]">
        <motion.img variants={{ hover: { scale: 1.06 } }} transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }} src={p.img} alt={p.name} className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_50%_35%,transparent_40%,rgba(11,17,32,0.35))]" />
        <span className="absolute top-[18%] left-1/2 -translate-x-1/2 font-mono text-[11px] uppercase tracking-widest bg-white/85 backdrop-blur px-3 py-1 rounded-full">{p.tag}</span>
      </div>
      <div className="pt-6">
        <div className="flex items-baseline justify-between gap-4">
          <h3 className="font-display text-2xl sm:text-3xl font-medium">{p.name}</h3>
          <p data-testid={`product-price-${p.id}`} className="font-mono text-sm text-[#1F6F99] whitespace-nowrap">{p.price}</p>
        </div>
        <p className="mt-3 text-[#475569] leading-relaxed">{p.desc}</p>
        <ul className="mt-5 space-y-2">
          {p.points.map((pt) => (
            <li key={pt} className="flex items-center gap-2.5 text-sm"><Check className="w-4 h-4 text-[#1F6F99]" />{pt}</li>
          ))}
        </ul>
        <a href={CONTACT.whatsapp} target="_blank" rel="noreferrer" data-testid={`product-order-${p.id}`} className="mt-6 inline-flex items-center gap-1.5 text-sm font-medium border-b border-[#0B1120] pb-0.5 hover:text-[#1F6F99] hover:border-[#1F6F99] transition-colors">
          Comandă <ArrowUpRight className="w-4 h-4 transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
        </a>
      </div>
    </motion.article>
  </Reveal>
);

export const Products = () => (
  <section id="produse" data-testid="products-section" className="relative bg-white py-24 sm:py-36">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal className="grid md:grid-cols-12 gap-6 items-end">
        <div className="md:col-span-7">
          <Eyebrow>Produse</Eyebrow>
          <h2 className="mt-5 font-display text-4xl sm:text-5xl lg:text-6xl font-semibold leading-[1.02] tracking-[-0.02em]">
            Trei forme, <span className="italic font-black text-[#5FB4E2]">același</span> gest simplu.
          </h2>
        </div>
        <p className="md:col-span-5 text-[#475569] leading-relaxed">Toate vin programate cu link-ul tău de recenzii Google și au cod QR pentru telefoanele fără NFC.</p>
      </Reveal>
      <div className="mt-16 grid md:grid-cols-3 gap-10 lg:gap-14">
        {PRODUCTS.map((p, i) => <ProductCard key={p.id} p={p} i={i} />)}
      </div>
    </div>
  </section>
);
